import { LevelDesignerElementBase } from "./element-base";

const elementClasses: Array<{ new (...args: any[]): LevelDesignerElementBase }> = [];

export function RegisterElement() {
    return function(constructor: { new (...args: any[]): LevelDesignerElementBase }) {
        elementClasses.push(constructor);
    };
}

export function getRegisteredElements() {
    return elementClasses;
} 
